import { Controller } from "@hotwired/stimulus"

const MAX_SHIFT = 160
const FADE_OUT_DISTANCE = 240
const SCROLL_RANGE = 1200
const RESTING_SHADE = 0.35

export default class extends Controller {
  static targets = ["line", "fade"]

  connect() {
    this.reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.frame = null
    this.schedule = this.schedule.bind(this)

    window.addEventListener("scroll", this.schedule, { passive: true })
    window.addEventListener("resize", this.schedule)

    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.schedule)
    window.removeEventListener("resize", this.schedule)

    if (this.frame) cancelAnimationFrame(this.frame)
  }

  schedule() {
    if (this.frame) return

    this.frame = requestAnimationFrame(() => {
      this.frame = null
      this.update()
    })
  }

  update() {
    this.moveLines()
    this.fadeAtEnd()
  }

  moveLines() {
    if (this.reduced) return

    const shift = this.progress() * Math.min(MAX_SHIFT, window.innerWidth * 0.1)

    this.lineTargets.forEach((line) => {
      const outward = line.dataset.side === "left" ? -shift : shift

      line.style.transform = `translateX(${outward.toFixed(1)}px)`
    })
  }

  fadeAtEnd() {
    if (!this.hasFadeTarget) return

    const left = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight)
    const nearEnd = this.clamp(left / FADE_OUT_DISTANCE, 0, 1)

    const shade = RESTING_SHADE + (1 - RESTING_SHADE) * this.progress()

    this.fadeTarget.style.opacity = (shade * nearEnd).toFixed(2)
  }

  progress() {
    return this.clamp(window.scrollY / SCROLL_RANGE, 0, 1)
  }

  clamp(value, min, max) {
    return Math.min(max, Math.max(min, value))
  }
}
